var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

export default isReactNative;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-form/es/isReactNative.js
// module id = 1239
// module chunks = 0